import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GridBaseQuery } from '@core';
import { InvestigationApproval } from '../../domain/entities/investigation-approval.entity';
import { InvestigationsApi } from '../api/investigations.api';
import { InvestigationApprovalMapper } from '../mappers/investigation-approval.mapper';

@Injectable({ providedIn: 'root' })
export class InvestigationApprovalsRepository {
  private readonly _api = inject(InvestigationsApi);
  private readonly _mapper = inject(InvestigationApprovalMapper);

  public getApprovalsWithPaging(query: GridBaseQuery): Observable<{ data: InvestigationApproval[]; totalElements: number }> {
    return this._api.getApprovalsWithPaging(query).pipe(
      map((result) => ({
        data: this._mapper.toDomainArray(result.data),
        totalElements: result.totalElements,
      })),
    );
  }
}
